import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class ToolroomProcessService extends Service {
	constructor(injector: Injector) {
		super("ToolroomProcess", injector);
	}
}
